module.exports = __webpack_public_path__ + "static/media/plus-tag-icon.fa0df29b.svg";